module.exports = "<div class=\"timepicker-container\">\n    <input class=\"form-control input-time\" #timepickerInput [ngxTimepicker]=\"timepicker\" [(ngModel)]=\"timeObject\" [value]=\"timeObject\"\n           [format]=\"24\">\n    <i class=\"glyphicon glyphicon-time timepicker-icon\" (click)=\"timepickerInput.click()\"></i>\n    <ngx-material-timepicker #timepicker [ngxMaterialTimepickerTheme]=\"customTheme\" (timeSet)=\"changeTimeObject($event)\"></ngx-material-timepicker>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/basic-components/dbm-time-picker/dbm-time-picker.component.html
// module id = 1882
// module chunks = 0